import { StyleSheet } from 'aphrodite';
import { CssSelectors } from '../../styles/styles';
import { THEME } from '../../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	modal: {
		boxSizing: 'border-box',
		...CssSelectors.allDescendants(
			{
				boxSizing: 'border-box',
				width: 400,
				margin: 'auto',
			},
			'.modal-overlay-content'
		),
	},

	content: {
		padding: THEME.spacing.lg,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: THEME.spacing.lg,
	},

	loadingContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: THEME.spacing.md,
		padding: THEME.spacing.xxl,
		color: THEME.colors.text.light,
	},

	qrContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		padding: THEME.spacing.lg,
		backgroundColor: THEME.colors.background.light,
		borderRadius: THEME.common.borderRadius,
		border: THEME.common.border,
	},

	qrImage: {
		maxWidth: 200,
		maxHeight: 200,
		width: 'auto',
		height: 'auto',
	},

	buttonContainer: {
		display: 'flex',
		gap: THEME.spacing.sm + THEME.spacing.xs,
		width: '100%',
		justifyContent: 'center',
	},

	button: {
		minWidth: 120,
	},

	errorContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: THEME.spacing.md,
		padding: THEME.spacing.xxl,
		color: THEME.colors.text.light,
		textAlign: 'center',
	},

	warningText: {
		backgroundColor: THEME.colors.warning.light,
		border: `1px solid ${THEME.colors.warning.main}`,
		borderRadius: THEME.spacing.xs / 2,
		padding: `${THEME.spacing.sm + THEME.spacing.xs}px ${THEME.spacing.md}px`,
		fontSize: THEME.typography.fontSizes.xs,
		lineHeight: '1.4',
		color: THEME.colors.warning.contrastText,
		textAlign: 'center',
		maxWidth: 280,
		width: '100%',
	},
});
